module.exports = __webpack_public_path__ + "img/wdevs-logo-og-image.d29121a8.jpg";